import { Suspense, } from 'react';
import { Route, Routes } from "react-router-dom";
import { UserAuthContextProvider } from "./context/UserAuthContext";
import './App.css';
import { ToastContainer } from 'react-toastify';
import Home from '../src/components/home/Home'
import "bootstrap/dist/css/bootstrap.min.css";
import Category from './components/categories/Category';
import CreateProfile from './components/createProfile/CreateProfile';
import ProtectedRoute from './components/createProfile/ProtectedRoute'
import Index from './components/dashboard/Index';
import BusinessAnalysis from './components/businessAnalysis/BusinessAnalysis';
import Profile from './components/vendorProfile/Profile';
import ProfilePicture from './components/vendorProfile/ProfilePicture';
import BusinessManagement from './components/dashboard/BusinessManagement';
import InvoiceBasicInfo from './components/invoiceMgmt/InvoiceBasicInfo';
import EditInvoiceInfo from './components/invoiceMgmt/EditInvoiceInfo';
import InvoiceItem from './components/invoiceMgmt/InvoiceItem';
import InvoiceTerms from './components/invoiceMgmt/InvoiceTerms';
import InvoiceCreate from './components/invoiceMgmt/InvoiceCreate';
import InoiceList from './components/invoiceMgmt/InoiceList';
import BasicDetails from './components/vendorProfile/BasicDetails';
import ThinksToKnowContainer from './components/vendorProfile/ThinksToKnowContainer';
import AddPreviousWork from './components/vendorProfile/previousWork/AddPreviousWork';
import AllPreviousWork from './components/vendorProfile/previousWork/AllPreviousWork';
import Calendar from './components/calendar/Calendar'
import CalendarList from './components/calendar/CalendarList'
import AddStaf from './components/staffMgmt/AddStaf';
import EditStaff from './components/staffMgmt/EditStaff';
import ProductList from './components/productMgmt/ProductList';
import AddProduct from './components/productMgmt/AddProduct';
import EditProduct from './components/productMgmt/EditProduct';
import BundlePackage from './components/packageMgmt/BundlePackage';
import AddPackage from './components/packageMgmt/AddPackage';
import EditBundlePackage from './components/packageMgmt/EditBundlePackage';
import TotalReviews from './components/reviews/TotalReviews';
import Reviews from './components/reviews/Reviews';
import Logout from './components/createProfile/Logout';
import Enquries from './components/enquries/UserRequests';
import BookVenue from './components/enquries/BookVenue';
import BlockedEvent from './components/enquries/BlockedEvent';
import VendorEnquire from './components/enquries/VendorEnquire';
import Subscriptions from './components/Subscriptions';
import InvoiceBasic from './components/invoiceMgmt/InvoiceBasic';
import Help from './components/Help';
import InvoiceMgmt from './components/invoiceMgmt/InvoiceMgmt';
import CustomSelect from './components/customSelect/CustomSelect';
import ChangePassword from './components/change-password/ChangePassword';
import UpdateEmail from './components/UpdateEmail';
import Badge from './components/badgeDecider/Badge';
import BasicHome from './components/createProfile/BasicHome';
import LoginWithMobileNumber from './components/LoginWithMobileNumber';
import Recharge from './components/recharge/Recharge';
import PaymentHistory from './components/history/PaymentHistory';
import TermCondition from '../TermCondition';
import PrivacyPolicy from './PrivacyPolicy';
import PromoCode from './components/PromoCode';
import PackageEnquiry from './components/packageMgmt/PackageEnquiry';
import LoginWithToken from './components/LoginWithToken';
import PackageLead from './components/PackageLead';
import { usePreventNumberInputArrowKeys } from './components/customHook/usePreventNumberInputArrowKeys';
import ClientQuotationForm from './components/clientQuotation/ClientQuotationForm';
import CorporateClientQuotationForm from './components/clientQuotation/CorporateClientQuotationForm';
import BirthdayClientQuotationForm from './components/clientQuotation/BirthdayClientQuotationForm';
import AnniversaryClientQuotationForm from './components/clientQuotation/AnniversaryClientQuotationForm';
import MobnoVerificationForm from './components/createProfile/MobnoVerificationForm';
import GoogleCategory from './components/categories/GoogleCategory';
import DeleteProfile from './components/createProfile/DeleteProfile';
import ProfileKyc from './components/vendorProfile/ProfileKyc';
import VenuePreviousWork from './components/vendorProfile/previousWork/VenuePreviousWork';
import TagImageManagement from './components/vendorProfile/previousWork/TagImageManagement';
import BusinessMap from './components/BusinessMap';
import WorkingAddress from './components/WorkingAddress';
import WorkingAddressList from './components/WorkingAddressList';
import SetEmailPassword from './components/SetEmailPassword';
import Packages from './components/Packages';
import VenueBookings from './components/VenueBookings';
import Services from './components/Services';
import LeadDashboard from './components/leadMgmt/LeadDashboard';
import UpdateLead from './components/leadMgmt/UpdateLead';
import UpdateLeadDetails from './components/leadMgmt/UpdateLeadDetails';
import LeadLog from './components/leadMgmt/LeadLog';

const App = () => {
  usePreventNumberInputArrowKeys();
  const renderLoader = () =>
    <>
      <div style={{ height: '100vh', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <div className="spinner-grow" role="status" style={{ height: '3rem', width: '3rem' }}>
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    </>;
  return (
    <UserAuthContextProvider>
      <Suspense fallback={renderLoader()}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path='category' element={<Category />} />
          <Route path='terms-condition' element={<TermCondition />} />
          <Route path='privacy-policy' element={<PrivacyPolicy />} />
          <Route path='delete-account' element={<DeleteProfile />} />
          <Route path='create-profile/:cat_id/:sub_cat_id' element={<CreateProfile />} />
          <Route path='link-number' element={<LoginWithMobileNumber />} />
          <Route path='basic-detail' element={<BasicHome />} />
          <Route path="login-with-token" element={<LoginWithToken />} />
          <Route path="vendor-category" element={<GoogleCategory/>} />
          <Route path='vendor-mobno-verification' element={<MobnoVerificationForm />} />
          <Route path='dashboard' element={<ProtectedRoute><Index /></ProtectedRoute>}>
            <Route path='business-map' element={<BusinessMap/>} />
            <Route path='package-enquiry' element={<PackageEnquiry />} />
            <Route path='offer' element={<PromoCode />} />
            <Route path="badge" element={<Badge />} />
            <Route path="packages" element={<Packages />} />
            <Route path='dash_board' element={<BusinessAnalysis />} />
            <Route path='package-lead' element={<PackageLead />} />
            <Route path='CustomSelect' element={<CustomSelect />} />
            <Route path='help' element={<Help />} />
            <Route path='profile' element={<Profile />} />
            <Route path='profile-picture' element={<ProfilePicture />} />
            <Route path='business-management' element={<BusinessManagement />} />
            <Route path='change-password' element={<ChangePassword />} />
            <Route path='change-email' element={<UpdateEmail />} />
            <Route path='invoice-basic' element={<InvoiceBasic />} />
            <Route path='invoice-item' element={<InvoiceItem />} />
            <Route path='invoice-terms' element={<InvoiceTerms />} />
            <Route path='invoice-create' element={<InvoiceCreate />} />
            <Route path='invoice-list' element={<InoiceList />} />
            <Route path='invoice-basic' element={<InvoiceBasicInfo />} />
            <Route path='invoice-management' element={<InvoiceMgmt />} />
            <Route path='edit-invoice/:id' element={<EditInvoiceInfo />} />
            <Route path='basic-detail' element={<BasicDetails />} />
            <Route path='thinks-to-know' element={<ThinksToKnowContainer />} />
            <Route path='previous-work' element={<AddPreviousWork />} />
            <Route path='previous-work-list' element={<AllPreviousWork />} />
            <Route path='calendar' element={<Calendar />} />
            <Route path='calendar-list' element={<CalendarList />} />
            <Route path='manage-staff' element={<AddStaf />} />
            <Route path='edit-staff/:id' element={<EditStaff />} />
            <Route path='product-list' element={<ProductList />} />
            <Route path='add-product' element={<AddProduct />} />
            <Route path='edit-product/:id' element={<EditProduct />} />
            <Route path='bundle-package' element={<BundlePackage />} />
            <Route path='create-package' element={<AddPackage />} />
            <Route path='edit_package/:id' element={<EditBundlePackage />} />
            <Route path="subscription" element={<Subscriptions />} />
            <Route path="total-reviews" element={<TotalReviews />} />
            <Route path='reviews' element={<Reviews />} />
            <Route path='services' element={<Services />} />
            <Route path="book-venue" element={<VenueBookings />} />
            <Route path="blocked-venue" element={<BlockedEvent />} />
            <Route path="user-enqueries" element={<VendorEnquire />} />
            <Route path="transaction-history" element={<PaymentHistory />} />
            <Route path='logout' element={<Logout />} />
           <Route path='wedding-client-quotation/:quotation_id' element={<ClientQuotationForm />} />
            <Route path='corporate-client-quotation/:quotation_id' element={<CorporateClientQuotationForm />} />
            <Route path='birthday-client-quotation/:quotation_id' element={<BirthdayClientQuotationForm />} />
            <Route path='anniversary-client-quotation/:quotation_id' element={<AnniversaryClientQuotationForm />} />
            <Route path='update-client-quotation/:quotation_id' element={<BirthdayClientQuotationForm />} />
            <Route path='profile-kyc' element={<ProfileKyc />} />
            <Route path='venue-previous-work' element={<VenuePreviousWork />} />
            <Route
              path="venue-previous-work/:tag_name"
              element={<TagImageManagement />}
            />
            <Route path='working-address' element={<WorkingAddress />} />
            <Route path='working-address-list' element={<WorkingAddressList />} />
            <Route path="set-email" element={<SetEmailPassword/>} />
            <Route path="lead-dashboard" element={<LeadDashboard />} />
            <Route path="update-lead/:id" element={<UpdateLead />} />
            <Route path="update-lead-details/:id" element={<UpdateLeadDetails />} />
            <Route path="lead-logs/:id" element={<LeadLog />} />
          </Route>
        </Routes>
      </Suspense>
      <ToastContainer />
    </UserAuthContextProvider>
  )
}

export default App
